import React, { useEffect, useRef } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

const InfoView: React.FC = () => {
  const { t } = useTranslation();
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.loaded);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <section className={styles.container}>
      <div ref={cardRef} className={styles.card}>
        <h2 className={styles.title}>
          {t('What is Impersonation')} <span className={styles.highlight}>{t('Account')}</span>?
        </h2>
        <p className={styles.description} dangerouslySetInnerHTML={{ __html: t('Impersonation_Description') }} />
      </div>
    </section>
  );
};

export default InfoView;
